import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http'
// import { WorkService } from './work.service.ts'
import { WorkService } from './work.service';
import { RouterModule } from '@angular/router';
import { SpinnerdetialComponent } from '../../helpers/loading/spinnerdetial/spinnerdetial.component';
import { NavbarComponent } from '../../components/navbar/navbar.component';

@Component({
  selector: 'app-work',
  standalone: true,
  imports: [CommonModule, HttpClientModule, RouterModule, SpinnerdetialComponent, NavbarComponent],
  templateUrl: './work.component.html',
  styleUrls: ['./work.component.scss']
})
export class WorkComponent implements OnInit {

  isLoading = false;

  dataProject = [
    {
      image: '../../../assets/nft/projectswork.png',
      headTitle: 'Angular Project',
      subTitle: 'Add dummby logos to your design quickly',
      status: 'New'
    },
    {
      image: '../../../assets/nft/projectswork.png',
      headTitle: 'Angular Project',
      subTitle: 'Add dummby logos to your design quickly',
      status: 'New'
    },
    {
      image: '../../../assets/nft/projectswork.png',
      headTitle: 'Angular Project',
      subTitle: 'Add dummby logos to your design quickly',
      status: 'New'
    },
    {
      image: '../../../assets/nft/projectswork.png',
      headTitle: 'Angular Project',
      subTitle: 'Add dummby logos to your design quickly',
      status: 'New'
    },
    {
      image: '../../../assets/nft/projectswork.png',
      headTitle: 'Angular Project',
      subTitle: 'Add dummby logos to your design quickly',
      status: 'New'
    },
  ]
  dataWork: any;
  role: any;

  constructor(private workService: WorkService) { }

  ngOnInit(): void {
    this.getDataWork()
    this.role = localStorage.getItem('role');
  }

  getDataWork(){
    this.isLoading = true;
    this.workService.doGetDataWork().subscribe((value: any) => {
      console.log(value)
      this.isLoading = false;
      this.dataWork = value.data
    })
  }

}
